import { render, staticRenderFns } from "./listado.vue?vue&type=template&id=c2c2a9ec&scoped=true"
import script from "./listado.vue?vue&type=script&lang=js"
export * from "./listado.vue?vue&type=script&lang=js"
import style0 from "./listado.vue?vue&type=style&index=0&id=c2c2a9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c2a9ec",
  null
  
)

export default component.exports